import React from "react";
import { logAnalyticsEvent } from "../../engagement/Amplitude";
import { useShowTempMessage } from "../../shared/hooks/useUtilityContext";

export default function GetPromptButton({ title }: { title: string }) {
  const showTempMessage = useShowTempMessage();
  return (
    <button
      type="button"
      className="text-sm btn-link"
      onClick={() => {
        logAnalyticsEvent("Get Prompt");
        navigator.clipboard.writeText(
          `Create a step by step guide to: \n\n${title}\n\nEach new step should start with a "#" Heading\n\nBe concise and use Markdown\n\n`
        );
        showTempMessage("Copied task to clipboard!");
      }}
    >
      Get Prompt
    </button>
  );
}